<ion-content @slideInLeft>
  <div class="menu-page">
    <!-- <div class="gradient-color"></div> -->
    <div class="simple-color"></div>
    <div class="menu-page__header">
      <div class="menu-page__header-texts">
        <div class="menu-page__title">
          {{ "Bienvenue" }} {{ this.user.client.first_name }}
        </div>
        <div class="menu-page__subtitle">
          {{ "Complétez votre profile" }}
        </div>
      </div>

      <div class="menu-page__progress">
        <app-progress-donut [progress]="completition" [size]="50" [strokeWidth]="9" [backgroundColor]="'#eaf2fb'"
          [innerFill]="'transparent'" [percentageColor]="'#ffffff'" [fontSize]="'.7em'"
          [fontWeight]="'bold'"></app-progress-donut>
      </div>
    </div>
    <div class="menu-page__panel">
      <section class="menu-page__content" [class.client]="this.role === 'client'">
        <div *ngIf="this.role === 'client'; then client; else prestataire"></div>
      </section>

      <div class="menu-page__logo-wrapper" (click)="onLogoTap()">
        <app-logo [src]="'../../../assets/icon/logo.png'" [alt]="'App Logo'" [width]="'50px'" [height]="'auto'"
          [showVersion]="false" [enableScale]="true" [className]="'menu-page__logo'"></app-logo>
      </div>
      <app-version></app-version>

    </div>

    <ng-container *ngIf="role === 'client'">
      <app-particulier-footer></app-particulier-footer>
    </ng-container>
    <ng-container *ngIf="role === 'prestataire'">
      <app-prestataire-footer></app-prestataire-footer>
    </ng-container>

    <ng-template #client>
      <div *ngFor="let item of clientMenu" class="menu-page__list-item" (click)="item.click()"
        [style]="'--icon: url(' + item.image + ')'" [class]="item.class">
        <div class="devider" *ngIf="item.class == 'logout'"></div>
        <div class="menu-page__list-name" tabindex="0">{{ item.label | uppercase }}</div>
        <div class="menu-page__list-item__notif" *ngIf="unreadConversations > 0 && item.class === 'messages'">
          {{unreadConversations|maxNumber:99}}
        </div>
        <div class="menu-page__list-item__notif" *ngIf="undreaded_admin_messages_count > 0 && item.class === 'contact'">
          {{undreaded_admin_messages_count|maxNumber:99}}
        </div>
        <div class="menu-page__list-item__notif" *ngIf="unreadNotificationsCount > 0 && item.class === 'notifications'"></div>
        <div class="menu-page__list-item__notif" *ngIf="item.class === 'profile' && completition < 100"
          (click)="toggleTooltip($event)">
          !
          <div class="menu-page__list-item__tooltip" *ngIf="showTooltip">
            {{ "PROFILE.PROFILE_COMPLETION.NOT_COMPLETE" | translate }}
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #prestataire>
      <div *ngFor="let item of prestaMenu" class="menu-page__list-item" (click)="item.click()"
        [style]="'--icon: url(' + item.image + ')'" [class]="item.class">
        <div class="devider" *ngIf="item.class == 'logout'"></div>

        <div class="menu-page__list-name" tabindex="0">{{ item.label | uppercase }}</div>
        <div class="menu-page__list-item__notif" *ngIf="unreadConversations > 0 && item.class === 'messages'">
          {{unreadConversations|maxNumber:99}}
        </div>
        <div class="menu-page__list-item__notif" *ngIf="undreaded_admin_messages_count > 0 && item.class === 'contact'">
          {{undreaded_admin_messages_count|maxNumber:99}}
        </div>
        <div class="menu-page__list-item__notif" *ngIf="unreadNotificationsCount > 0 && item.class === 'notifications'"></div>
        <div class="menu-page__list-item__notif" *ngIf="item.class === 'profile' && completition < 100"
          (click)="toggleTooltip($event)">
          !
          <div class="menu-page__list-item__tooltip" *ngIf="showTooltip">
            {{ "PROFILE.PROFILE_COMPLETION.NOT_COMPLETE" | translate }}
          </div>
        </div>
      </div>

    </ng-template>
  </div>
</ion-content>